<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <h5>Serwis Telefonów 
                    <router-link class="btn btn-circle torre-red mt-2" :to="{ name: 'servicesNew' }" title="Dodaj serwis" >
                        <i class="material-icons" >
                        add
                        </i>
                    </router-link>
                </h5>
            </div>
        </div>
        <table class="table table-hover">
            <thead>
                <tr>
                <th class="">
                    <div class="input-group-sm mb-2">
                        <input class="form-control" @keyup="onTextChanged" v-model="form.phoneName"/>
                    </div>
                </th>
                <th class="align-top">
                    <div class="input-group-sm align-top mb-2">
                        <select @change="reloadContent()" class="form-control" v-model="form.reasonKey">
                            <option v-for="option in reasonOptions" :key="option.id" v-bind:value="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                </th>
                <th class="align-top">
                    <div class="input-group-sm align-top mb-2">
                    <label >Data</label>
                    </div>
                </th>
                <th class="align-top">
                    <div class="input-group-sm align-top mb-2">
                        <select @change="reloadContent()" class="form-control" v-model="form.storeId">
                            <option v-for="option in storesOptions" :key="option.id" v-bind:value="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                </th>
                <th class="align-top">
                    <div class="input-group-sm align-top mb-2">
                    <label >Pracownik</label>
                    </div>
                </th>
                <th class="align-top">
                    <div class="input-group-sm align-top mb-2">
                    <label >Kwota do zapł.</label>
                    </div>
                </th>
                <th class="align-top">
                    <div class="input-group-sm align-top mb-2">
                    <label >Zysk</label>
                    </div>
                </th>
                <th class="align-top">
                    <div class="input-group-sm align-top mb-2">
                    <label >Status</label>
                    </div>
                </th>
                <th class="align-top">
                    <div class="input-group-sm align-top mb-2">
                    <label >Edycja/Podgląd</label>
                    </div>
                </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in services" :key="item.id" :class="determineClass(item)">
                    <td>{{ item.phoneName }}</td>
                    <td>{{ item.serviceReason }}</td>
                    <td>{{ formatDate(item.acceptanceDate) }}</td>
                    <td>{{ item.storeName }}</td>
                    <td>{{ item.createdBy }}</td>
                    <td>{{ formatPrice(item.servicePrice) }}</td>
                    <td>{{ calculateIncome(item) }}</td>
                    <td>{{ statusName(item.serviceStatus) }}</td>
                    <td><router-link :to="{ name: 'servicesEdit', params: { id: item.id} }">edytuj</router-link></td>
                </tr>
            </tbody>
        </table>
        <div v-if="showEmptyResult" class="row">
            <div class="col text-center">
                Brak wyników
            </div>
        </div>
        <common-pagination @paginationClicked="onPaginationClicked"/>
    </div>
</template>
<script>

import alertify from 'alertifyjs';
import un from 'underscore'
import ServicesManager from "@/components/service/ServicesManager"

const servicesManager = new ServicesManager()

export default {
    name: "ServicesList",
    data: () => {
        return {
            storesOptions: [],
            reasonOptions: [],
            services: [],
            loading: false,
            rawStatuses: servicesManager.rawStatuses,
            colorStatuses: servicesManager.colorStatuses,
            form: {
                phoneName: "",
                reasonKey: "",
                storeId: 0
            },
            pageable: {
                page: 0
            }
        }
    },
    computed: {
        showEmptyResult() {
            return this.loading === false && this.services.length === 0
        },
        isAdmin() {
            return servicesManager.isAdmin()
        }
    },
    created() {
        this.loadConfig()
        this.initStoresOptions()
    },
    methods: {
        determineClass(item) {
            return this.colorStatuses[item.serviceStatus]
        },
        statusName(rawStatus) {
            return this.rawStatuses[rawStatus]
        },
        calculateIncome(item) {
            const income = item.servicePrice - item.serviceRepairPrice
            return this.formatPrice(income)
        },
        formatPrice(servicePrice) {
            return servicesManager.formatPrice(servicePrice)
        },
        formatDate(serviceDate) {
            return servicesManager.formatDate(serviceDate)
        },
        onTextChanged: un.debounce(function (e) {
            this.pageable.page = 0;
            this.reloadContent();
        }, 300),
        reloadContent() {
            const data = {
                params: this.form,
                pageable: this.pageable
            }
            servicesManager.searchServices(data, this.onSearchSuccess, this.onSearchError)
        },
        onSearchSuccess(data) {
            this.services = data.items
            this.$emit('dataChanged', {
                data: data
            });
        },
        onSearchError(err) {
            console.log(err)
        },
        initStoresOptions() {
            servicesManager.initStores(this.onStoresSuccess)
        },
        onStoresSuccess(data, selectedStoreId) {
            this.storesOptions = this.initStores(data)
            this.form.storeId = selectedStoreId
            this.reloadContent()
        },
        initStores(options) {
            const finalList = []
            const defaultOption = {
                id: "0",
                name: "wszystkie"
            }
            finalList.push(defaultOption)
            for (var i in options) {
                var item = options[i]
                finalList.push({
                    id: item.id,
                    name: item.name
                })
            }
            return finalList
        },
        loadConfig() {
            servicesManager.loadConfig(this.onConfigSuccess, this.onConfigError)
        },
        onConfigSuccess(data) {
            this.reasonOptions = this.initReasons(data.reasons)
        },
        onConfigError(err) {
            console.log(err)
        },
        initReasons(options) {
            const finalList = []
            const defaultOption = {
                id: "",
                name: "wybierz"
            }
            finalList.push(defaultOption)
            for (var i in options) {
                var item = options[i]
                finalList.push({
                    id: item.key,
                    name: item.value
                })
            }
            return finalList
        },
        onPaginationClicked(payload) {
            var pageToSend = payload.pageToSend;
            this.pageable.page = pageToSend;
            this.reloadContent();
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/service/ServicesList.vue